<script lang="ts">
export default {
  name: 'DisclaimerModal',
};
</script>

<script setup lang="ts">
import { computed, onBeforeMount, ref } from 'vue';
import { disclaimerService } from '@/services/v2/DisclaimerService';
import { Disclaimer } from '@/types/Disclaimer';
import { Commit } from '@/store';
import { StoreMutationType } from '@/types/StoreMutationType';
import { Auth } from 'aws-amplify';
import { sanitizeRichText } from '@/utilities/Sanitization';

const props = defineProps<{
  disclaimerType: string;
}>();

const disclaimerTitle = 'CAC Legal Disclaimer';
const showModal = ref<boolean>(true);
const disclaimer = ref<Disclaimer>({} as Disclaimer);

onBeforeMount(async () => {
  disclaimer.value = await disclaimerService.getDisclaimerByType(props.disclaimerType);
});

const disclaimerText = computed(() => {
  const text = disclaimer.value?.text?.replace(/(?:\r\n|\r|\n)/g, '<br>') ?? '';
  // Sanitize to prevent XSS while allowing basic formatting
  return sanitizeRichText(text);
});

async function acceptDisclaimer(): Promise<void> {
  await disclaimerService.acceptDisclaimer(disclaimer.value.id);
  Commit(StoreMutationType.ACCEPT_LEGAL_DISCLAIMER);
  showModal.value = false;
}

function logout(): void {
  Auth.signOut();
}
</script>

<template>
  <v-dialog v-model="showModal" scrollable max-width="600px" persistent data-testid="disclaimer-modal">
    <v-card>
      <v-card-title><span class="text-h5">{{ disclaimerTitle }}</span></v-card-title>
      <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component -->
      <v-card-text v-html="disclaimerText" data-testid="disclaimer-text">
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="flat" size="small" color="primary" @click="acceptDisclaimer">Accept</v-btn>
        <v-btn variant="flat" size="small" @click="logout">Reject</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
